import React from 'react'
import _ from 'lodash'
import styled from 'styled-components'
import { darken } from 'polished'
import Checkmark from './Checkmark'
import NextIcon from './NextIcon'
import BackIcon from './BackIcon'

const BACKGROUND_COLORS = {
  active: 'white',
  inactive: 'white',
  share: 'blue4',
  disabled: 'grey14',
  completed: 'green1',
  neutral: 'white',
  next: 'white',
  back: 'white',
}

const COLORS = {
  active: 'black',
  inactive: 'black',
  disabled: 'black',
  neutral: 'green',
  completed: 'green',
  next: 'black',
  back: 'grey2',
}

const backgroundColor = (props) => (
  props.theme.colors[BACKGROUND_COLORS[props.type]] || props.theme.colors.green
)

const color = (props) => (
  props.theme.colors[COLORS[props.type]] || props.theme.colors.white
)

const fontWeight = (props) => (
  _.includes(['active', 'submit'], props.type) ? 500 : 400
)

const BORDERS = {
  neutral: 'outline',
  next: 'outline',
  back: 'outline',
}

const border = (props) => (
  props.theme.borders[BORDERS[props.type]] || 'none'
)

const BOX_SHADOWS = {
  active: 'greenLight',
  inactive: 'greyLight',
}

const boxShadow = (props) => (
  props.theme.boxShadow[BOX_SHADOWS[props.type]] || 'none'
)

const Container = styled.button`
  font-family: 'Lato', sans-serif;
  background-color: ${props => backgroundColor(props)};
  border: 0;
  color: ${props => color(props)};
  box-shadow: ${boxShadow};
  min-width: ${props => props.width || '150px'};
  padding: ${props => props.padding || '10px 5px'};
  margin: ${props => props.center ? '0 auto' : '0 10px'};
  border-radius: ${props => props.borderRadius || props.theme.borderRadius.round};
  font-size: ${props => props.fontSize || (props.small ? '14px' : '16px')};
  font-weight: ${props => fontWeight(props)};
  display: flex;
  flex-basis: 1;
  flex-grow: 0;
  justify-content: center;
  align-items: center;
  text-align: center;
  cursor: pointer;
  border: ${props => border(props)};

  &:hover {
    background-color: ${props => darken(0.05, backgroundColor(props))};
  }

  ${props => props.nav && props.type === 'completed' && `@media (max-width: 768px) {
    color: #38A36A;
  }`}

  @media (max-width: 768px) {
    margin: 0 2px;
  }
`

export default ({ children, type, loading, ...rest }) => (
  <Container disabled={loading} type={loading ? 'disabled' : type} {...rest}>
    {type === 'back' && <BackIcon />} {type === 'completed' && <Checkmark />} {children} {type === 'next' && <NextIcon />}
  </Container>
)
